import { CSSProperties, FC } from "react";
import { useMediaQuery } from "@mui/material";
import Link from "next/link";
import { ISlug } from "@Types/Breadcrumbs";
import { breadcrumbsSelector } from "@wff/store/breadcrumbsSlice";
import { useAppSelector } from "@wff/store/hooks";
import classes from "./Breadcrumb.module.scss";

interface IBreadcrumbProps {
  style?: CSSProperties;
}
const Breadcrumb: FC<IBreadcrumbProps> = ({ style }) => {
  // let the style prop for custom inline styles (Required in PDP because of custom position for large screens).
  const breadcrumbs = useAppSelector(breadcrumbsSelector);
  const { slugs = [] } = breadcrumbs || {};
  const lastIndex = slugs.length > 1 ? slugs.length - 1 : slugs.length;
  const isMobile = useMediaQuery("(max-width:960px)");
  return (
    <nav
      className={classes["breadcrumb"]}
      style={{ ...style, width: !isMobile ? "100%" : "inherit" }}
    >
      <div className={classes["breadcrumb-container"]}>
        {slugs?.map((slug: ISlug, i: number) => {
          let validSlug = "";

          if (lastIndex === i) {
            validSlug = slug.title ? slug.title : "";
          } else {
            validSlug = slug.title ? `${slug.title} > ` : "";
          }

          if (slug?.link) {
            return (
              <div
                key={`breadcrumb-slug-${validSlug}`}
                className={classes["link-container"]}
              >
                <Link href={slug.link}>
                  <a>{validSlug}</a>
                </Link>
              </div>
            );
          } else {
            return (
              validSlug && (
                <div className={classes["plain-text-container"]}>
                  <span
                    className={classes["slug-container"]}
                    style={{ width: isMobile ? "100%" : "none" }}
                    key={`breadcrumb-slug-${validSlug}`}
                  >
                    {validSlug}
                  </span>
                </div>
              )
            );
          }
        })}
      </div>
    </nav>
  );
};

export default Breadcrumb;
